import { render, staticRenderFns } from "./InfoBlocksTable.vue?vue&type=template&id=d589d35a&scoped=true"
import script from "./InfoBlocksTable.vue?vue&type=script&lang=js"
export * from "./InfoBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./InfoBlocksTable.vue?vue&type=style&index=0&id=d589d35a&prod&lang=css"
import style1 from "./InfoBlocksTable.vue?vue&type=style&index=1&id=d589d35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d589d35a",
  null
  
)

export default component.exports